import client from './client';

// List all groups
export const listGroups = async () => {
  try {
    const res = await client.get('/groups');
    return res.data;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// List stores for a specific group
export const listGroupStores = async (groupId) => {
  const res = await client.get(`/groups/${groupId}/stores`);
  return res.data;
};

// Create a new group
export const createGroup = async (groupData) => {
  try {
    const res = await client.post('/groups', groupData);
    return res.data;
  } catch (error) {
    console.error('API: Create group failed:', error);
    throw error;
  }
};

// Add stores to an existing group (legacy - creates new stores)
export const addStoresToGroup = async (groupId, storesData) => {
  const res = await client.post(`/groups/${groupId}/stores`, storesData);
  return res.data;
};

// Assign/unassign stores to a group (updates existing stores)
export const assignStoresToGroup = async (groupId, storesData) => {
  const res = await client.post(`/groups/${groupId}/assign-stores`, storesData);
  return res.data;
};

// Update a group
export const updateGroup = async (groupId, groupData) => {
  try {
    const res = await client.put(`/groups/${groupId}`, groupData);
    return res.data;
  } catch (error) {
    console.error('API: Update group failed:', error);
    throw error;
  }
};

// Delete a group
export const deleteGroup = async (groupId) => {
  const res = await client.delete(`/groups/${groupId}`);
  return res.data;
};
